import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: 'mrcMortgageRates',
    inject: ['$eventBus'],
    props: {
        options: {
            type: Object,
            default: function () {
                return {
                    showNormalMrc: true,
                    cta: '',
                    utm_campaign: 'apply',
                    ga: 'partner_mortgage_listings_session',
                    desc: '',
                };
            },
        },
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit', 'getPrevHotlead']),
        ...mapGetters('dpp', ['dpp']),
        isMobileProperty(){
            return this.dpp && ['MOBILE'].includes(this.dpp.propertyType);
        }
    },
    mounted() {
        let userInfo = null;
        if (this.options.utm_campaign === 'sellerTYP') {
            this.$eventBus.$emit('ga', { en: 'long_form', ec: 'partner_mortgage_sellerTYP_session', el: 'MRC', props: { link_name: 'Get Started' } });
        } else if (this.options.showEquityMrc) {
            this.$eventBus.$emit('ga', { en: 'long_form', ec: this.options.ga , el: 'MRC',props: { link_name: this.options.cta } });
        } else if (!this.options.showNormalMrc) {
            if(this.isMobileProperty){
                this.$eventBus.$emit('ga', { en: 'long_form', ec: 'partner_mortgage_postre_session_mobile', el: 'MRC'});
            } else if (this.options.cta) {
                this.$eventBus.$emit('ga', { en: 'long_form', ec: 'partner_mortgage_postre_session', el: 'MRC', props: { link_name: this.options.cta } });
            } else {
                this.$eventBus.$emit('ga', { en: 'long_form', ec: this.options.ga || 'partner_mortgage_postre_session',  el: 'MRC' });
            }
            userInfo =  {full_name: this.getPrevHotlead.hotlead.name,
                        email: this.getPrevHotlead.hotlead.email,
                        phone: this.getPrevHotlead.hotlead.phone};
        } else {
            if(this.isMobileProperty){
                this.$eventBus.$emit('ga', { en: 'long_form', ec: 'partner_mortgage_listings_session_mobile', el: ' MRC', props: { link_name: this.options.cta} });
            } else  {
                if(this.options.ga){
                    this.$eventBus.$emit('ga', { en: 'long_form', ec: this.options.ga, el: 'MRC', props: { link_name: this.options.cta } });
                }
            }
        }
        const propertyTypes = {
            SINGLE_FAMILY_HOUSE: 'Single',
            CONDO: 'Condominium',
            MULTI_FAMILY: 'Multifamily',
            LAND: 'Other',
            MOBILE: 'Manufactured',
            OTHER: 'other',
        };
        this.onWindowFmctyValues({
            utm_campaign: this.options.utm_campaign,
            desc: this.options.desc,
            ...userInfo,
            property_value: (this.dpp && this.dpp.price) || '',
            property_zip: (this.dpp && this.dpp.geo && this.dpp.geo.zipcode) || '',
            property_type: (this.dpp && propertyTypes[this.dpp.propertyType]) || '',
            lp_s1: this.glb.user.id,
        });
        window.submissionReturn = function  (data)  {
            console.log('Received data' +  data);
        };;

        this.$eventBus.$once('eventbus-dialog-close', () => {
            this.$eventBus.$emit('eventbus-hotlead-step', { trigger: this.$options.name });
        });
    },
    methods: {
        ...mapActions('glb'),
        onWindowFmctyValues(data) {
            window.Fmcty = window.Fmcty || {};
            window.Fmcty.values = {
                ...window.Fmcty.values,
                ...data,
            };
        },
    },
};
